import { __decorate, __metadata, __param } from "tslib";
import { Component, Inject, Input } from 'angular-ts-decorators';
import template from './random-staff-member.component.html';
var RandomStaffMemberComponent = (function () {
    function RandomStaffMemberComponent(staff) {
        this.staff = staff;
        this.dimensions = 100;
    }
    RandomStaffMemberComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.staff
            .getPhotos(1, Number(this.dimensions))
            .then(function (photos) { _this.photo = photos[0]; });
    };
    RandomStaffMemberComponent.$inject = ['staff'];
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], RandomStaffMemberComponent.prototype, "dimensions", void 0);
    RandomStaffMemberComponent = __decorate([
        Component({
            selector: 'randomStaffMember',
            template: template,
        }),
        __param(0, Inject('staff')),
        __metadata("design:paramtypes", [Object])
    ], RandomStaffMemberComponent);
    return RandomStaffMemberComponent;
}());
export { RandomStaffMemberComponent };
